var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "show_chart_black_24dp"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "none",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.5 18.49 11.5 12.48 15.5 16.48 21 9.48 19.59 8.07 15.5 13.48 11.5 9.48 4 16.99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3,6 L1,6 L1,11 L1.01,11 L1,20 C1,21.1 1.9,22 3,22 L21,22 L21,20 L3,20 L3,6 Z",
    id: "Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.83ccd04c4fbcf62e9bb957400bcb5ff1.svg";
export { ForwardRef as ReactComponent };